<template>
  <IdentificationFormContainer
    @transfer="(data)=>$emit('transfer', data)"
    @lockFwdBtn="(value)=>$emit('lockFwdBtn', value)"
    :income="income"
    :document="formData.document ? formData.document : null"
    :formData="formData"
    ref="identificationFormContainer"
  />
</template>

<script>
  import IdentificationFormContainer from "../components/IdentificationFormContainer";

  export default {
    props: ['income', 'formData'],
    components: {
      IdentificationFormContainer
    },
    methods: {
      transferData() {
        return this.$refs.identificationFormContainer.transferData()
      }
    }
  }
</script>
